import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ContentBlock } from '../../models';

@Component({
  selector: 'app-content-block-cta',
  templateUrl: './content-block-cta.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentBlockCtaComponent {
  @Input() block!: ContentBlock;
}
